module.exports = __webpack_public_path__ + "img/NOMBRELOGO.c1000670.png";